import ApiHttp from '../http';

class EcomTrackingService {

    buildImpressionsQuery(products) {
        dataLayer.push({
            'event': 'productImpressions',
            'ecommerce': {
                'impressions': products
            }
        });
    } 

    buildProductClickQuery(product) {
        dataLayer.push({
            'event': 'productClick',
            'ecommerce': {
                'click': {
                    'products': [product]
                 }
            }
        });
    }

    buildProductDetailViewQuery(product) {
        dataLayer.push({
            'event': 'productView',
            'ecommerce': {
                'detail': {
                    'products': [product]
                 }
            }
        });
    }

    buildAddTicketToBasketQuery(product) {
        dataLayer.push({
            'event': 'addToCart',
            'ecommerce': {
                'add': {
                    'products': [product]
                 }
            }
        });
    }

    buildRemoveTicketFromBasketQuery(product) {
        dataLayer.push({
            'event': 'removeFromCart',
            'ecommerce': {
                'remove': {
                    'products': [product]
                 }
            }
        });
    }

    buildCheckoutProductsBasketQuery(products) {
        dataLayer.push({
            'event': 'checkout',
            'ecommerce': {
                'checkout': {
                    'actionField': {'step': 1},
                    'products': products
                 }
            }
        });
    }

    buildCheckoutBasketStepTwo() {
        //TODO: movie step 2 to booking page 4 if possible

        dataLayer.push({
            'event': 'checkout',
            'ecommerce': {
                'checkout': {
                    'actionField': {'step': 2}
                 }
            }
        });
    }

    buildSuccessfulTransactionQuery(total, transactionId, products, cinemaName) {
        dataLayer.push({
            'event': 'purchase',
            'ecommerce': {
                'purchase': {
                    'actionField': {
                        'id': transactionId,
                        'revenue': total,
                        'affiliation': cinemaName,
                    },
                    'products': products
                 }
            }
        });
    }

    buildProductViewQuery(product) {
        // console.log("userId", this.userId)
        dataLayer.push({
            'event': 'productView',
            'ecommerce': {
                'detail': {
                    'products': [product],
                 }
            }        
        });
    }

    doDataLayerImpression(movie, position) {

        let product = {
            name: movie.title,
            id: movie.id,
            category: movie.coming_soon ? 'Coming Soon' : 'Now Showing',
            list: 'Home',
            position: position
        }

        this.buildImpressionsQuery([product])
    }

    doDataLayerProductClick(movie, movies, now_showing, coming_soon) {
        let list = (now_showing ? movies.now_showing : movies.coming_soon) || []
        let position = list.indexOf(movie) + 1

        let product = {
            name: movie.title,
            id: movie.id,
            category: movie.coming_soon ? 'Coming Soon' : 'Now Showing',
            list: 'Home',
            position: position
        }

        this.buildProductClickQuery(product);
    }

    doDataLayerProductDetailView(movie) {
        // console.log("doDataLayerProductDetailView", movie);
        var product = {"name":movie.title,
        "id":movie.id,"category":(movie.coming_soon ? "Coming Soon" : "Now Showing")}
        this.buildProductViewQuery(product)
    }

    addTicketToHumanzTracking(item) {
        let humanzItems = localStorage.getItem("humanzTracking")
        if(humanzItems != undefined && humanzItems != null) {
            if(humanzItems.length > 0) {
                let items = JSON.parse(humanzItems);
                items.push(item)
                localStorage.setItem("humanzTracking", JSON.stringify(items))
            } else {
                let items = []
                items.push(item)
                localStorage.setItem("humanzTracking", JSON.stringify(items))
            }
        } else {
            let items = []
            items.push(item)
            humanzItems = items
            localStorage.setItem("humanzTracking", JSON.stringify(humanzItems))
        }
    }

    removeTicketToHumanzTracking(item) {
        let humanzItems = localStorage.getItem("humanzTracking")
        if(humanzItems != undefined && humanzItems != null) {
            let items = JSON.parse(humanzItems);
            let index = items.findIndex(i => i.id = item.id)
            items.splice(index, 1)
            localStorage.setItem("humanzTracking", JSON.stringify(items))
        }
    }

    doDataLayerAddTicketToBasket(product) {
        console.log("doDataLayerAddTicketToBasket", product);
        if(product != undefined && product != null) {
            var item = {"name":product.FilmTitle,"id":product.TicketTypeCode,"price":(product.PriceCents? parseFloat(product.PriceCents/100).toFixed(2): parseFloat(product.PriceInCents/100).toFixed(2)),"category":"Ticket",quantity:1,"variant":product.Description}
        }
        console.log("item", item)
        this.addTicketToHumanzTracking(item)
        this.buildAddTicketToBasketQuery(item)
    }

    doDataLayerRemoveTicketFromBasket(product) {
        console.log("doDataLayerRemoveTicketFromBasket", product);
        if(product != undefined && product != null) {
            var item = {"name":product.FilmTitle,"id":product.TicketTypeCode,"price":(product.PriceCents? parseFloat(product.PriceCents/100).toFixed(2): parseFloat(product.PriceInCents/100).toFixed(2)),"category":"Ticket",quantity:1,"variant":product.Description}
        }

        // console.log("item", item)
        this.removeTicketToHumanzTracking(item)
        this.buildRemoveTicketFromBasketQuery(item)
    }

    doDataLayerRemoveConcessionFromBasket(product) {
        console.log("doDataLayerRemoveConcessionFromBasket", product);
        var item = {"name":product.FilmTitle,"id":product.Id,"price":(product.PriceCents? parseFloat(product.PriceCents/100).toFixed(2): parseFloat(product.PriceInCents/100).toFixed(2)),"category":"Extras",quantity:1,"variant":product.Description}
        this.buildRemoveTicketFromBasketQuery(item)
    }

    doDataLayerAddConcessionToBasket(product) {
        console.log("doDataLayerAddConcessionToBasket", product);
        var item = {"name":product.FilmTitle,"id":product.Id,"price":(product.PriceCents? parseFloat(product.PriceCents/100).toFixed(2): parseFloat(product.PriceInCents/100).toFixed(2)),"category":"Extras",quantity:1,"variant":product.Description}
        this.buildAddTicketToBasketQuery(item)
    }

    doDataLayerCommitBasket(products, filmTitle) {
        // console.log("doDataLayerCommitBasket", products, filmTitle);
        //change all product names to be film titles. 
        var items = [];

        //TODO: film title for product name below for each item

        if(products.tickets.added.length > 0) {
            for(var ta in products.tickets.added) {
                var item = {"name":filmTitle,"id":products.tickets.added[ta].TicketTypeCode,"price":(products.tickets.added[ta].PriceCents? parseFloat(products.tickets.added[ta].PriceCents/100).toFixed(2): parseFloat(products.tickets.added[ta].PriceInCents/100).toFixed(2)),"category":"Ticket",quantity:1,"variant":products.tickets.added[ta].Description}
                items.push(item)
            }
        }

        if(products.loyalties.added.length > 0) {
            for(var la in products.loyalties.added) {
                // console.log("ecom tracking", products.loyalties.added[la])
                if(products.loyalties.added[la].TicketType != undefined && products.loyalties.added[la].TicketType != null) {
                    var item = {"name":filmTitle,"id":products.loyalties.added[la].TicketType.TicketTypeCode,"price":(products.loyalties.added[la].TicketType.PriceCents? parseFloat(products.loyalties.added[la].TicketType.PriceCents/100).toFixed(2): parseFloat(products.loyalties.added[la].TicketType.PriceInCents/100).toFixed(2)),"category":"Ticket",quantity:1,"variant":products.loyalties.added[la].TicketType.Description}
                        items.push(item)
                } else {
                    var item = {"name":filmTitle,"id":products.loyalties.added[la].TicketTypeCode,"price":(products.loyalties.added[la].PriceCents? parseFloat(products.loyalties.added[la].PriceCents/100).toFixed(2): parseFloat(products.loyalties.added[la].PriceInCents/100).toFixed(2)),"category":"Ticket",quantity:1,"variant":products.loyalties.added[la].Description}
                    items.push(item)
                }
                
            }
        }

        if(products.concessions.added.length > 0) {
            for(var ca in products.concessions.added) {
                var item = {"name":filmTitle,"id":products.concessions.added[ca].Id,"price":(products.concessions.added[ca].PriceCents? parseFloat(products.concessions.added[ca].PriceCents/100).toFixed(2): parseFloat(products.concessions.added[ca].PriceInCents/100).toFixed(2)),"category":"Extras",quantity:1,"variant":products.concessions.added[ca].Description}
                items.push(item)
            }
        }

        

        if(items.length > 0) {
            localStorage.setItem('EcomItems', JSON.stringify(items));
            this.buildCheckoutProductsBasketQuery(items)
        }
    }

    doCheckoutBasketStepTwo() {
        this.buildCheckoutBasketStepTwo();
    }

    doSuccessfulTransaction(booking) {
        // console.log("doSuccessfulTransaction", booking);
        var total = 0;
        var items = JSON.parse(localStorage.getItem('EcomItems'));
        let cinemaName = ""
        let movieName = ""
        //
        
        var transactionId = "";

        for(var b in booking) {
            transactionId = booking[0].BookingId
            cinemaName = booking[0].CinemaName
            movieName = booking[0].MovieName
        }

        for(var i in items) {
            total = total + parseFloat((items[i].price))
            items[i].name = movieName
        }

        Promise.resolve(this.buildSuccessfulTransactionQuery(total, transactionId, items, cinemaName)).then((result) => {
            this.doHumanzSuccessfulTransactionTracking(transactionId)
            localStorage.removeItem("EcomItems");
        })
    }

    lHzpAsy(u, c) {
        var d = document, t = 'script',
        o = d.createElement(t),
        s = d.getElementsByTagName(t)[0];
        o.src = u;
        if (c) { o.addEventListener('load', function (e) { c(null, e); }, false); }
        s.parentNode.insertBefore(o, s);
    }

    doHumanzSuccessfulTransactionTracking(transactionId) {
  //      Promise.resolve(this.lHzpAsy()).then((result) => {
            let humanzItems = localStorage.getItem("humanzTracking")
            if(humanzItems != undefined && humanzItems != null) {
                if(humanzItems.length > 0) {
                    let items = JSON.parse(humanzItems);
                    
                    this.lHzpAsy("https://assets.humanz.com/2633024/humanz-gtm.js", function () {
                    try {
                        var hmz = new window.hzi("2633024");
                        var h = window.hzp;
                        var products = items || [];
                        var coupon = "";
                        var orderId = transactionId || ""
                        if (h) {
                            h.gtmPurchaseKey(products,coupon,orderId);
                            localStorage.removeItem("humanzTracking")
                        }
                    } catch (e) { }
                    });
                }
            }
//        })
    }
}

export default new EcomTrackingService();



// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/service/ecom-tracking-service.js